import Title from 'antd/es/typography/Title';
import styles from './index.module.scss';

interface ContentHeaderProps {
  title: string;
}

export default function ContentHeader({ children, title }: React.PropsWithChildren<ContentHeaderProps>) {
  return (
    <div className={styles.contentHeader}>
      <Title level={4} className={styles.title}>
        {title}
      </Title>
      <div className={styles.actions}>{children}</div>
    </div>
  );
}
